import React, { useState,  useEffect, createContext } from 'react';
import { FaMapMarkerAlt } from 'react-icons/fa';
import './i18n';  //// import i18n (needs to be bundled ;)) 
import { useTranslation } from 'react-i18next';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import { useAppCtx } from './app-ctx';

import Stars from './Stars';
import Slideshow from './slide-show';
import ImageMatrix from './image-matrix';
import ResortFeaturesList from './resort-feaure-list';
import RoomTypes from './resort-room-types';


import './resort-details-full-tabbed-v1.css';



/**
 * 
        $resortModel->resort_id = $resortData->resort_id;
        $resortModel->name = $resortData->name;
        $resortModel->stars = $resortData->stars;
        $resortModel->address = $resortData->address;
        $resortModel->treatment_from = $resortData->treatment_from;
        $resortModel->city_id = $resortData->city_id;
        $resortModel->city_name = $resortData->city_name;
        $resortModel->region_id = $resortData->region_id;
        $resortModel->region_name = $resortData->region_name;
        $resortModel->attrs = $resortData->attrs;

        $resortModel->rooms = $resortData->rooms;
        $resortModel->descriptionsRaw = $resortData->descriptions;

            $resortModel->description = $desc->description;
            $resortModel->descriptionRooms = $desc->description;
            $resortModel->descriptionBoardings = $desc->description;
            $resortModel->descriptionServices = $desc->description;
            $resortModel->descriptionAdditionalServices = $desc->description;
            $resortModel->descriptionTreatmentServices = $desc->description;
            $resortModel->descriptionCancellationPolicy = $desc->description;
            
        $resortModel->imagesRaw = [ { // all images
                            resort_id;
                            relation,
                            filename,
                            path,
                            mime 
                    },
                    ....
        ]
        $resortModel->images = [ {  // all images except main (one with 'relation' == 0)
                resort_id;
                relation,
                filename,
                path,
                mime 
            },
            ...
        ]
        $resortModel->mainImage = {
            resort_id;
            relation
            filename 
            path
            mime ;
        }
 * */


const ResortDetailsFullTabbed = ({theResort, moreImagesClick}) => {
    const { t } = useTranslation();
    const { searchCriterias } = useAppCtx();
    const [ tabIndex, setTabIndex ] = useState(0);

    //console.log('ResortDetailsFullTabbed(): Entry: theResort=', JSON.stringify(theResort));
    console.log('ResortDetailsFullTabbed(): Entry: searchCriterias=', JSON.stringify(searchCriterias));

    const handeMoreImagesClick = (evt) => {
        if (moreImagesClick)
            moreImagesClick(evt);
    }

    const handleToBookOnClick = () => {
        console.log('ResortDetails.handleToBookOnClick()');
    }

    return (
        <div className='main-description-tabbed'>
            <div className='address-description-rooms-wrapper'>
                <h1><span>{theResort.name}</span> <Stars rating={theResort.stars} maxStars={5}/></h1>
                <address><FaMapMarkerAlt style={{ color: '#4a4a4a', marginRight: 6, verticalAlign: '-0.1em' }} />{theResort.address}</address>
            </div>

            <Tabs selectedIndex={tabIndex} onSelect={index => setTabIndex(index)}>
                <TabList>
                    <Tab>{t('Description')}</Tab>
                    <Tab>{t('Services')}</Tab>
                    <Tab>{t('Treatment')}</Tab>
                    <Tab>{t('Boarding')}</Tab>
                </TabList>
                <TabPanel>  {/* Description */}
                    <div className='tab tab-1 tab-description'>
                        <div className='section-1'>
                            <div className='main-image-wrapper'>
                                <Slideshow images={theResort.imageUrlsAll} autoPlay={true} interval={3000} transition="slide" 
                                    showArrows={false} showDots={false} showButton={false} />
                            </div>

                            <div className='features-prices-wrapper'>
                                
                                <div className='features-wrapper'>
                                    <div>
                                        <h6 className='topic'><img src={theResort.icons['features']} alt="features" className="topic-icon " />
                                            <span>{t('Features')}</span></h6>
                                        <ResortFeaturesList features={theResort.features} />
                                    </div>
                                </div>

                                <div className='rooms-wrapper'>
                                    <h6 className='topic'><img src={theResort.icons['rooms']} alt="rooms" className="topic-icon " />
                                        <span>{t('Room Types Available')}</span></h6>
                                    <RoomTypes resortId={theResort.resort_id} 
                                        roomsData={theResort.rooms} 
                                        occupacyValue={searchCriterias.occupacyValue} 
                                        dietaryValue={searchCriterias.dietaryValue} 
                                        dateRangeValue={searchCriterias.dateRangeValue} />

                                    <div className="book-button-container">
                                        <a className="book-button button is-primary" onClick={handleToBookOnClick} 
                                            href={theResort.toBookUrl}>{t("Book Now")}</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='main-description-wrapper'>
                            <h6 className='topic'><img src={theResort.icons['description']} alt="description" className="topic-icon " />
                                <span>{t('Description')}</span></h6>
                            <div className='p' dangerouslySetInnerHTML={{ __html: theResort.description }} />
                        </div>

                        <div className='room-description-wrapper'>

                            <div>
                                <h6 className='topic'><span><img src={theResort.icons['rooms']} alt="rooms" className="topic-icon " />
                                    </span><span>{t('Rooms')}</span></h6>
                                <div className='p' dangerouslySetInnerHTML={{ __html: theResort.descriptionRooms }} />
                            </div>
                        </div>
                    </div>
                </TabPanel> {/* /Description */}
                <TabPanel>  {/* Services */}
                    <div className='tab tab-2 tab-services'>

                        <div className='services-description-wrapper'>
                            <h6 className='topic'><img src={theResort.icons['services']} alt="services" className="topic-icon " />
                                <span>{t('Services')}</span></h6>
                            <div className='p' dangerouslySetInnerHTML={{ __html: theResort.descriptionServices }} />
                        </div>

                        <div className='additional-services-description-wrapper'>
                            <h6 className='topic'><img src={theResort.icons['additional_services']} alt="additionalServices" className="topic-icon " />
                                <span>{t('Additional services')}</span></h6>
                            <div className='p' dangerouslySetInnerHTML={{ __html: theResort.descriptionAdditionalServices }} />
                        </div>

                    </div>
                </TabPanel> {/* /Services */}
                <TabPanel>  {/* Treatment */}
                    <div className='tab tab-3 tab-treatment'>

                        <div className='treatment-description-wrapper'>
                            <h6 className='topic'><img src={theResort.icons['treatment']} alt="treatment" className="topic-icon " />
                                <span>{t('Treatment')}</span></h6>
                            <div className='p' dangerouslySetInnerHTML={{ __html: theResort.descriptionTreatmentServices }} />
                        </div>

                    </div>
                </TabPanel> {/* /Treatment */}
                <TabPanel>  {/* Boarding */}
                    <div className='tab tab-4 tab-boarding'>
                        <div className='boarding-description-wrapper'>
                            <h6 className='topic'><img src={theResort.icons['boardings']} alt="boardings" className="topic-icon " />
                                <span>{t('Boardings')}</span></h6>
                            <div className='p' dangerouslySetInnerHTML={{ __html: theResort.descriptionBoardings }} />
                        </div>

                        <div  className='boardings-list-wrapper'>
                            <ul className='boardings-list'>{theResort.boardings.map(board => (
                                    <li className='board-item' key={board.board_id}>{board.description}</li>
                                ))}
                            </ul>
                        </div>

                        <div className='cancellation-policy-description-wrapper'>
                            <h6 className='topic'><img src={theResort.icons['cancellation_policy']} alt="cancellationPolicy" className="topic-icon " />
                                <span>{t('Cancellation policy')}</span></h6>
                            <div className='p' dangerouslySetInnerHTML={{ __html: theResort.descriptionCancellationPolicy }} />
                        </div>

                    </div>
                </TabPanel> {/* /Boarding */}
            </Tabs>
        </div>
    );
}

export default ResortDetailsFullTabbed;